import axios from '@/util/request'
import store from '@/store'
const baseURL = process.env.VUE_APP_API_URL

export default {
  // 产品页面列表
  getProductOpenList: data => axios({ baseURL, url: store.state.common.token ? '/api/product/getWebPageList' : '/api/product/open/openList', data, method: 'post' }), // 列表
  getProductOpenMenu: params => axios({ baseURL, url: '/api/product/productShopWindow/list', params, method: 'get' }), // 列表
  getMainProductList: data => axios({ baseURL, url: '/api/product/open/main', data, method: 'post' }), // 列表

  // 帮助中心
  // getEssayList: data => axios({ baseURL, url: '/api/product/open/essay/list', data, method: 'POST' }), // 文章列表
  getEssayList: data => axios({ baseURL, url: 'api/product/latest-blog', data, method: 'get' }), // 文章列表  新接口
  getEssayCategory: data => axios({ baseURL, url: '/api/product/open/essay/classification/list', data, method: 'POST' }), // 文章分类列表
  getEssayById: data => axios({ baseURL, url: '/api/product/open/essay/getEssayById', data, method: 'POST' }), // Tutoral文章列表（开放接口）
  getEssayDetail: essayId => axios({ baseURL, url: `/api/product/open/essay/get/${essayId}`, method: 'get' }), // 文章细节

  putCustomerFeedback: data => axios({ baseURL, url: '/api/message/open/customerFeedback', data, method: 'POST' }), // 客户新增反馈信息

  // set API
  getStoreDeveloperToken: data => axios({ baseURL, url: '/api/store/developer/token', data, method: 'post' }), // 前台-获取开发者token
  setStoreDeveloperToken: data => axios({ baseURL, url: '/api/store/developer/token', data, method: 'put' }), // 前台-刷新开发者token

  // set webHooks
  getMessageWebhook: data => axios({ baseURL, url: '/api/message/webhook', data, method: 'get' }), // 前台-获取开发者token
  setMessageWebhook: data => axios({ baseURL, url: '/api/message/webhook', data, method: 'put' }), // 前台-刷新开发者token

  getSiteMapAggregation: data => axios({ baseURL, url: '/api/product/open/siteMapAggregation', method: 'get', data }), // sitemap
  getAggregationTitleBySiteMap: params => axios({ baseURL, url: '/api/product/open/aggregationTitleBySiteMap', method: 'get', params }), // 根据站点地图获取聚合信息标题
  getCategorySiteMapProductList: data => axios({ baseURL, url: '/api/product/open/categorySiteMapProductList', method: 'POST', data }), // 获取分类站点地图产品列表

  // 博客列表
  getPromotionLatestBlog: params => axios({ baseURL, url: '/api/product/latest-blog/seo', method: 'get', params }) // 获取最新推广博客列表

}
